import { FormTextArea, type FormTextAreaProps } from "@prismicio/editor-ui"
import {
  type Control,
  type FieldValues,
  type Path,
  useController,
} from "react-hook-form"

interface HookFormTextAreaProps<T extends FieldValues>
  extends Omit<
    FormTextAreaProps,
    "value" | "onValueChange" | "onBlur" | "ref" | "error"
  > {
  control: Control<T>
  name: Path<T>
}

export function HookFormTextArea<T extends FieldValues>(
  props: HookFormTextAreaProps<T>,
) {
  const { control, name, ...restProps } = props

  const { field, fieldState } = useController({
    control,
    name,
  })

  return (
    <FormTextArea
      {...restProps}
      name={name}
      value={field.value ?? ""}
      onChange={field.onChange}
      onBlur={field.onBlur}
      ref={field.ref}
      error={fieldState.error?.message}
    />
  )
}
